import { useConfig as hook, BaseConfig } from '@eika-infrastruktur/config-provider';

import { TranslationsConfigType, nbTranslations, nnTranslations } from './translations';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface Link {
    target?: string;
    text?: string;
    url: string;
}

export interface Config extends BaseConfig {
    siteLang: 'nb' | 'nn';
    translations: {
        nb: TranslationsConfigType;
        nn: TranslationsConfigType;
    };
    sdoLink: Link;
    featureToggles: {
        // @default true
        enableOpenOtherDocumentsInAppBrowser: boolean;
    };
}

export const defaultConfig: Config = {
    siteLang: 'nb' as const,
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    sdoLink: {
        url: 'https://www.sign.nets.eu/validator/index.html',
    },
    featureToggles: {
        enableOpenOtherDocumentsInAppBrowser: true,
    },
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
